import { Component, OnInit } from '@angular/core';
import * as vars from '../../global/vars';
import * as funtions from '../../global/functions';

import { Game } from '../../classes/game';
import { GamesService } from '../../services/games.service';

@Component({
  selector: 'darkadia-game-nav',
  templateUrl: './game-nav.component.html',
  styleUrls: ['./game-nav.component.scss']
})
export class GameNavComponent implements OnInit {
  private appTitle = vars.title;

  private games: Game[];
  private gameLinkList: Game[][];
  private colNumber = 1;

  constructor(private gamesService: GamesService) {
    this.games = [];
    this.gameLinkList= [];
  }

  ngOnInit() {
    this.getGames();
    let gamesQuantity:number = this.games.length;
    if (gamesQuantity > 20) {
      this.colNumber = 3;
      this.gameLinkList.push(this.games.splice(0, gamesQuantity / 3));
      this.gameLinkList.push(this.games.splice(0, gamesQuantity / 3));
      this.gameLinkList.push(this.games);
    } else if (gamesQuantity > 10) {
      this.colNumber = 2;
      this.gameLinkList.push(this.games.splice(0, gamesQuantity / 2));
      this.gameLinkList.push(this.games);
    } else {
      this.colNumber = 1;
      this.gameLinkList.push(this.games);
    }
  }

  getGames(): void {
    this.gamesService.getGames().forEach(element => {
      this.games.push(element);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/game-nav/game-nav.component.ts